import React from "react";
import "./LpReviews.css"

const LpReviewsHead = () => {
  return (
    <div className="lpReviewsHead-container">
      <div className="lpReviewsHead-content">
        <h5>Review</h5>
      </div>
      <h2>
        What Our <span>Customers</span> Says
      </h2>
    </div>
  );
};

export default LpReviewsHead;
